import { render, staticRenderFns } from "./exported.vue?vue&type=template&id=8feb5a38&"
import script from "./exported.vue?vue&type=script&lang=js&"
export * from "./exported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports